import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 11.731H5c-2.8 0-5 2.151-5 4.888v1.955c0 .587.4.978 1 .978s1-.391 1-.978v-1.955c0-1.662 1.3-2.932 3-2.932h7c1.7 0 3 1.27 3 2.932v1.955c0 .587.4.978 1 .978s1-.391 1-.978v-1.955c0-2.737-2.2-4.888-5-4.888M8.5 9.776c2.8 0 5-2.15 5-4.888S11.3 0 8.5 0s-5 2.151-5 4.888 2.2 4.888 5 4.888m0-7.82c1.7 0 3 1.27 3 2.932s-1.3 2.933-3 2.933-3-1.27-3-2.933 1.3-2.932 3-2.932m15.2 4.203a.98.98 0 0 0-1.4 0L19 9.386l-1.3-1.27a.98.98 0 0 0-1.4 0 .93.93 0 0 0 0 1.368l2 1.955c.2.196.5.293.7.293s.5-.098.7-.293l4-3.91a.93.93 0 0 0 0-1.369z"
    }, null, -1)
  ]))]))
}
export default { render: render }